import axios from 'axios';
import { getUrl } from '@/config/api.routes';
const basePath = 'management.smart_control';
import { buildEncodedUrl } from '@/libs/urlencoding';


export default {
  namespaced: true,
  state: {
    smartControlList: [],
    smartContol: {},
    rules: [],
    rule: {},
  },
  mutations: {
    SET_SMART_CONTROL_LIST(state, list) {
      state.smartControlList = list;
    },
    SET_SMART_CONTROL(state, item) {
      state.smartContol = item;
    },
    SET_RULES(state, list) {
      state.rules = list;
    },
    SET_RULE(state, item) {
      state.rule = item;
    },
  },
  actions: {
    async getSmartControlList({ commit }, payload) {
      const [params, searchOffset] = payload;

      const url = buildEncodedUrl(
        getUrl(`${basePath}.control`),
        params,
      );

      const response = await axios.get(url);
      if (!searchOffset) {
        //append to previous list
        commit('SET_SMART_CONTROL_LIST', [...this.state.smartControl.smartControlList, ...response.data.models]);
      } else {
        commit('SET_SMART_CONTROL_LIST', response.data.models);
      }
      return response;
    },
    async getSmartControl({ commit }, id) {
      const response = await axios.get(getUrl(`${basePath}.control`, id));
      commit('SET_SMART_CONTROL', response.data);
      return response;
    },
    async SmartControlAction(_, payload) {
      const { id, action, reason } = payload;
      const url = `${getUrl(`${basePath}.control`)}/act/${id}/${action}`;
      const response = await axios.put(url, reason ? { reason } : {});
      return response;
    },

    async fetchComments(_, payload) {
      const { id } = payload;
      const url = `${getUrl(`${basePath}.control`)}/${id}/comments`;
      const response = await axios.get(url);
      return response;
    },
    async addComment(_, payload) {
      const { id, comment, parent_id } = payload;
      const url = `${getUrl(`${basePath}.control`)}/${id}/comments`;
      const response = await axios.post(url, parent_id ? { content: comment, parent_id } : { content: comment });
      return response;
    },

    async deleteComment(_, payload) {
      const { id, comment_id } = payload;
      const url = `${getUrl(`${basePath}.control`)}/${id}/comments/${comment_id}`;
      const response = await axios.delete(url);
      return response;
    },


    async createVersion(_, payload) {
      const {id, data} = payload;
      const url = `${getUrl(`${basePath}.control`)}/${id}/versions`;
      return axios.post(url, data);
    },

    async getRuleList({ commit }, payload) {
      const [params, searchOffset] = payload;

      const url = buildEncodedUrl(
        getUrl(`${basePath}.rule`),
        params,
      );

      const response = await axios.get(url);

      if (!searchOffset) {
        //append to previous list
        commit('SET_RULES', [...this.state.smartControl.rules, ...response.data.models]);
      } else {
        commit('SET_RULES', response.data.models);
      }
      return response;
    },
    async getRule({ commit }, id) {
      const response = await axios.get(getUrl(`${basePath}.rule`, id));
      commit('SET_RULE', response.data);
      return response;
    },
    async createRule(_, payload) {
      const response = await axios.post(getUrl(`${basePath}.rule`), payload);
      return response;
    },

    async updateRule(_, payload) {
      const { id, data } = payload;
      const response = await axios.put(getUrl(`${basePath}.rule`, id), data);
      return response;
    },

    deleteRule(_, id) {
      return axios.delete(getUrl(`${basePath}.rule`, id));
    },
    getRuleDocuments(_, id) {
      const url = `${getUrl(`${basePath}.rule`, id)}/documents`;
      return axios.get(url);
    },
    fetchStages() {
      return axios.get(getUrl(`${basePath}.stages`));
    },
  },
};
